import HomeLayout from '@/layouts/Home.vue'
export const RRHHRoutes = [
  {
    path: '/hr',
    name: 'hr',
    component: () => import('./views/EmployeesManagement.vue'),
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['RRHH', 'admin', 'supervisor', 'employee'],
    },
  },
  {
    path: '/Externalletters',
    name: 'hr-letters',
    component: () => import('./views/ExternalLetters.vue'),
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['RRHH', 'admin', 'supervisor', 'employee'],
    },
  },
]
